
const BASE_URL = process.env.REACT_APP_BASE_URL

const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL

export {BASE_URL, FRONTEND_URL};
